// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__xzQWZ","sub":"styles_sub__xYNW5","add":"styles_add__9Ds0f"};